// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 语音合成节点样式 */
.TextToAudioNode-wrapper {
  width: 320px;
}

.TextToAudioNode-field {
  margin-bottom: 12px;
}

.TextToAudioNode-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.TextToAudioNode-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.TextToAudioNode-select:focus {
  outline: none;
  border-color: #667eea;
}

.TextToAudioNode-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.TextToAudioNode-loading-voices {
  padding: 8px 12px;
  background-color: #f0f0f0;
  border-radius: 6px;
  font-size: 13px;
  color: #666;
  text-align: center;
}

/* 音色选择器 */
.TextToAudioNode-voice-selector {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
}

.TextToAudioNode-voice-info {
  flex: 1;
}

.TextToAudioNode-voice-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.TextToAudioNode-voice-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.TextToAudioNode-voice-actions {
  display: flex;
  gap: 6px;
  margin-top: 6px;
}

.TextToAudioNode-voice-preview-btn {
  padding: 6px 10px;
  background: #fff;
  color: #667eea;
  border: 1px solid #667eea;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
}

.TextToAudioNode-voice-preview-btn:hover {
  background: #667eea;
  color: white;
}

.TextToAudioNode-voice-preview-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.TextToAudioNode-voice-change-btn {
  flex: 1;
  padding: 6px 12px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.TextToAudioNode-voice-change-btn:hover {
  background: #5568d3;
}

.TextToAudioNode-voice-change-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.TextToAudioNode-voice-select-btn {
  width: 100%;
  padding: 10px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.TextToAudioNode-voice-select-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.TextToAudioNode-voice-select-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* 高级设置 */
.TextToAudioNode-advanced-toggle {
  margin-bottom: 12px;
}

.TextToAudioNode-toggle-button {
  width: 100%;
  padding: 8px 12px;
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.TextToAudioNode-toggle-button:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.TextToAudioNode-toggle-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.TextToAudioNode-advanced {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid #e9ecef;
}

.TextToAudioNode-slider {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  background: #ddd;
  cursor: pointer;
}

.TextToAudioNode-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #667eea;
  cursor: pointer;
  transition: all 0.2s ease;
}

.TextToAudioNode-slider::-webkit-slider-thumb:hover {
  background: #5568d3;
  transform: scale(1.1);
}

.TextToAudioNode-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #667eea;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

.TextToAudioNode-slider::-moz-range-thumb:hover {
  background: #5568d3;
  transform: scale(1.1);
}

.TextToAudioNode-slider:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.TextToAudioNode-slider:disabled::-webkit-slider-thumb {
  cursor: not-allowed;
  background: #999;
}

.TextToAudioNode-slider:disabled::-moz-range-thumb {
  cursor: not-allowed;
  background: #999;
}

/* 提示信息 */
.TextToAudioNode-hint {
  font-size: 11px;
  color: #999;
  line-height: 1.5;
  margin-bottom: 12px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #667eea;
}

/* 生成按钮 */
.TextToAudioNode-generate {
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 8px;
}

.TextToAudioNode-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.TextToAudioNode-generate:active {
  transform: translateY(0);
}

.TextToAudioNode-generate-disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* 错误提示 */
.TextToAudioNode-error {
  padding: 10px 12px;
  background-color: #fee;
  color: #c33;
  border-radius: 6px;
  font-size: 12px;
  margin-top: 8px;
  border-left: 3px solid #c33;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/TextToAudioNode.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B","sourcesContent":["/* 语音合成节点样式 */\n.TextToAudioNode-wrapper {\n  width: 320px;\n}\n\n.TextToAudioNode-field {\n  margin-bottom: 12px;\n}\n\n.TextToAudioNode-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 6px;\n}\n\n.TextToAudioNode-select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background-color: white;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.TextToAudioNode-select:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.TextToAudioNode-select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.TextToAudioNode-loading-voices {\n  padding: 8px 12px;\n  background-color: #f0f0f0;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #666;\n  text-align: center;\n}\n\n/* 音色选择器 */\n.TextToAudioNode-voice-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.TextToAudioNode-voice-info {\n  flex: 1;\n}\n\n.TextToAudioNode-voice-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.TextToAudioNode-voice-desc {\n  font-size: 12px;\n  color: #666;\n  line-height: 1.4;\n}\n\n.TextToAudioNode-voice-actions {\n  display: flex;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.TextToAudioNode-voice-preview-btn {\n  padding: 6px 10px;\n  background: #fff;\n  color: #667eea;\n  border: 1px solid #667eea;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n}\n\n.TextToAudioNode-voice-preview-btn:hover {\n  background: #667eea;\n  color: white;\n}\n\n.TextToAudioNode-voice-preview-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.TextToAudioNode-voice-change-btn {\n  flex: 1;\n  padding: 6px 12px;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.TextToAudioNode-voice-change-btn:hover {\n  background: #5568d3;\n}\n\n.TextToAudioNode-voice-change-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.TextToAudioNode-voice-select-btn {\n  width: 100%;\n  padding: 10px 12px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.TextToAudioNode-voice-select-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.TextToAudioNode-voice-select-btn:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* 高级设置 */\n.TextToAudioNode-advanced-toggle {\n  margin-bottom: 12px;\n}\n\n.TextToAudioNode-toggle-button {\n  width: 100%;\n  padding: 8px 12px;\n  background: #f8f9fa;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.TextToAudioNode-toggle-button:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.TextToAudioNode-toggle-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.TextToAudioNode-advanced {\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  border: 1px solid #e9ecef;\n}\n\n.TextToAudioNode-slider {\n  width: 100%;\n  height: 6px;\n  border-radius: 3px;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background: #ddd;\n  cursor: pointer;\n}\n\n.TextToAudioNode-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #667eea;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.TextToAudioNode-slider::-webkit-slider-thumb:hover {\n  background: #5568d3;\n  transform: scale(1.1);\n}\n\n.TextToAudioNode-slider::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #667eea;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s ease;\n}\n\n.TextToAudioNode-slider::-moz-range-thumb:hover {\n  background: #5568d3;\n  transform: scale(1.1);\n}\n\n.TextToAudioNode-slider:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.TextToAudioNode-slider:disabled::-webkit-slider-thumb {\n  cursor: not-allowed;\n  background: #999;\n}\n\n.TextToAudioNode-slider:disabled::-moz-range-thumb {\n  cursor: not-allowed;\n  background: #999;\n}\n\n/* 提示信息 */\n.TextToAudioNode-hint {\n  font-size: 11px;\n  color: #999;\n  line-height: 1.5;\n  margin-bottom: 12px;\n  padding: 8px;\n  background: #f8f9fa;\n  border-radius: 4px;\n  border-left: 3px solid #667eea;\n}\n\n/* 生成按钮 */\n.TextToAudioNode-generate {\n  width: 100%;\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 8px;\n}\n\n.TextToAudioNode-generate:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.TextToAudioNode-generate:active {\n  transform: translateY(0);\n}\n\n.TextToAudioNode-generate-disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* 错误提示 */\n.TextToAudioNode-error {\n  padding: 10px 12px;\n  background-color: #fee;\n  color: #c33;\n  border-radius: 6px;\n  font-size: 12px;\n  margin-top: 8px;\n  border-left: 3px solid #c33;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
